module.exports = __webpack_public_path__ + "img/profile_settings.1fc215ca.svg";